import React from 'react';
import { ProductSizeFit } from '../../../integrations/relewise/types/mapped';

const SIZE_GUIDE_PAGE_URL = '/size-guide';

const resolveSizeGuideUrl = (rawUrl: string | undefined, sitePath: string | undefined): string | undefined => {
    if (!rawUrl) {
        return undefined;
    }

    if (/^https?:\/\//i.test(rawUrl)) {
        return rawUrl;
    }

    const normalizedSitePath = (sitePath ?? '').replace(/\/$/, '');
    const normalizedPath = rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`;

    return `${normalizedSitePath}${normalizedPath}`;
};

export interface SizeFitGuidanceProps {
    fit: ProductSizeFit | undefined;
    sizeGuideUrl?: string;
    sitePath: string | undefined;
    runsSmallText: string;
    runsLargeText: string;
    sizeGuideLinkText: string;
}

export const SizeFitGuidance = (props: SizeFitGuidanceProps) => {
    const { fit, sizeGuideUrl, sitePath, runsSmallText, runsLargeText, sizeGuideLinkText } = props;

    if (fit !== 'small' && fit !== 'large') {
        return null;
    }

    const message = fit === 'small' ? runsSmallText : runsLargeText;
    // `||` on purpose: the config default is an empty string.
    const resolvedSizeGuideUrl = resolveSizeGuideUrl(sizeGuideUrl || SIZE_GUIDE_PAGE_URL, sitePath);
    const hasSizeGuideLink = Boolean(resolvedSizeGuideUrl);

    return (
        <div className='new-buybox__size-fit-guidance' data-testid='size-fit-guidance'>
            <span className='new-buybox__size-fit-icon' aria-hidden='true' />
            <p className='new-buybox__size-fit-message'>
                {message}
                {hasSizeGuideLink && (
                    <>
                        {' '}
                        <a
                            className='new-buybox__size-fit-link'
                            href={resolvedSizeGuideUrl}
                            target='_blank'
                            rel='noopener noreferrer'
                            data-testid='size-fit-guide-link'
                        >
                            {sizeGuideLinkText}
                        </a>
                    </>
                )}
            </p>
        </div>
    );
};
